import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { connect } from 'react-redux';
import prependLanguageToLink from './prepend-language-to-link';
var handleClick = function handleClick(defaultOnClick) {
  return defaultOnClick();
};
var Link = function Link(_ref) {
  var id = _ref.id,
    to = _ref.to,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    children = _ref.children,
    target = _ref.target,
    rel = _ref.rel,
    siteLanguage = _ref.siteLanguage,
    dataTrack = _ref.dataTrack,
    dataTrackAction = _ref.dataTrackAction,
    dataTrackLabel = _ref.dataTrackLabel,
    state = _ref.state;
  return /*#__PURE__*/React.createElement(ReactRouterLink, {
    target: target,
    rel: rel,
    "data-track": dataTrack,
    "data-track-action": dataTrackAction,
    "data-track-label": dataTrackLabel,
    id: id,
    className: "".concat(className, " trackable-link"),
    onClick: function onClick() {
      return handleClick(_onClick);
    },
    state: state,
    to: prependLanguageToLink(siteLanguage, to)
  }, children);
};
var mapStateToProps = function mapStateToProps(_ref2) {
  var application = _ref2.application;
  return {
    siteLanguage: application.siteLanguage
  };
};
export default connect(mapStateToProps)(Link);